import { create } from "zustand";
import { ConditionPhasesTypes } from "../../../types/samples.types";

type UseTabStore = {
  phaseSelected: ConditionPhasesTypes;
  setPhaseSelected: (phase: ConditionPhasesTypes) => void;
  tabValue: number;
  setTabValue: (tab: number) => void;
  tabValueAnalysis: number;
  setTabValueAnalysis: (tab: number) => void;
};

export const useTabs = create<UseTabStore>((set) => ({
  phaseSelected: "initial",
  setPhaseSelected: (phase) => set({ phaseSelected: phase }),
  tabValue: 0,
  setTabValue: (tab) => set({ tabValue: tab }),
  tabValueAnalysis: 0,
  setTabValueAnalysis: (tab) => set({ tabValueAnalysis: tab }),
}));

export default useTabs;
